import { decommissionedDeviceStore } from "../decommissionedDeviceStore"

export const useDecommissionedDeviceStore = () => {
  const devices = decommissionedDeviceStore((state) => state.devices)
  const loading = decommissionedDeviceStore((state) => state.loading)
  const error = decommissionedDeviceStore((state) => state.error)
  const pageInfo = decommissionedDeviceStore((state) => state.pageInfo)

  const getDecommissionedDevices = decommissionedDeviceStore(
    (state) => state.getDecommissionedDevices,
  )
  const reset = decommissionedDeviceStore((state) => state.reset)

  return {
    devices,
    loading,
    error,
    pageInfo,
    getDecommissionedDevices,
    reset,
  }
}

export default useDecommissionedDeviceStore
